import React from 'react';
import s from './RadioGroup.module.scss';

interface RadioItem {
  label: string;
  value: string | number;
}

interface RadioGroupProps {
  label?: string;
  name: string;
  items: RadioItem[] | string[];
  onChange?: (id: string) => void;
  isRequired?: boolean;
  value?: string;
  isError?: boolean;
  helperText?: string;
  dataTestId?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label = '',
  items,
  name,
  isRequired = false,
  isError = false,
  helperText = '',
  dataTestId = '',
  onChange = () => {},
}) => {
  const onValueChange = (e: React.ChangeEvent<HTMLDivElement>) => {
    const target = e.target as HTMLInputElement;
    if (typeof onChange === 'function') {
      onChange(target.id);
    }
  };

  const renderRadioItem = (item: RadioItem | string) => {
    const value = typeof item === 'string' ? item : item.value;
    const label = typeof item === 'string' ? item : item.label;

    return (
      <div key={value} className={s.radioContainer}>
        <input type="radio" name={name} id={value.toString()} />
        <p className={s.radioLabel}>{label}</p>
      </div>
    );
  };

  return (
    <div className={s.container}>
      <p>{`${label}${isRequired ? ' *' : ''}`}</p>
      <div onChange={onValueChange} className={s.content} data-testid={dataTestId}>
        {items.map(renderRadioItem)}
      </div>
      {isError && <p className={s.helperText}>{helperText}</p>}
    </div>
  );
};

export default RadioGroup;
